import { useState } from "react";
import { trackCustomDestinationToggled } from "../../analytics.ts";

interface DestinationRowProps {
  connectedAddress: string;
  value: string;
  onChange: (v: string) => void;
}

export function DestinationRow({ connectedAddress, value, onChange }: DestinationRowProps) {
  const [customDest, setCustomDest] = useState(false);

  function toggleMode() {
    if (customDest) {
      setCustomDest(false);
      onChange(connectedAddress);
      trackCustomDestinationToggled({ mode: "own_wallet" });
    } else {
      setCustomDest(true);
      onChange("");
      trackCustomDestinationToggled({ mode: "custom" });
    }
  }

  const truncated = !customDest && connectedAddress
    ? `${connectedAddress.slice(0, 6)}...${connectedAddress.slice(-4)}`
    : null;

  return (
    <div
      className="rounded-2xl px-4 py-3 flex items-center gap-3 border border-white/10"
      style={{ background: "#0e1a2a" }}
    >
      {/* Icon toggle */}
      <button
        type="button"
        onClick={toggleMode}
        className={`shrink-0 transition-colors ${
          customDest ? "text-ghost-white" : "text-mist hover:text-ghost-white"
        }`}
        aria-label={customDest ? "Use own wallet" : "Enter custom address"}
        title={customDest ? "Use own wallet" : "Enter custom address"}
      >
        {customDest ? (
          // Pencil icon
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              d="M12.5 2.5L15.5 5.5L6 15H3V12L12.5 2.5Z"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          // Wallet icon
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <rect x="1.5" y="4.5" width="15" height="11" rx="2" stroke="currentColor" strokeWidth="1.4"/>
            <path d="M1.5 7.5H16.5" stroke="currentColor" strokeWidth="1.4"/>
            <circle cx="13" cy="11" r="1" fill="currentColor"/>
          </svg>
        )}
      </button>

      {/* Address display / input */}
      {customDest ? (
        <input
          type="text"
          placeholder="Enter destination address"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="font-mono text-sm text-ghost-white bg-transparent outline-none flex-1 placeholder:text-ash/40"
          autoFocus
        />
      ) : (
        <span className="font-mono text-sm text-ghost-white flex-1">
          {truncated ?? <span className="text-ash/50">Connect wallet</span>}
        </span>
      )}
    </div>
  );
}
